import IconResolver from "../../../shared/components/common/ui/IconResolver";
import StatusLabel from "../../../shared/components/StatusLabel/StatusLabel";
import ThemeColors from "../../../shared/components/ThemeColors/ThemeColors";
import { truncateText } from "../../../shared/utils/utils";
 
const compactCol = (extra = {}) => ({
  width: 80,
  sortable: false,
  filterable: false,
  ...extra,
});

const textCol = (extra = {}) => ({
  flex: 1,
  minWidth: 180,
  ...extra,
});

export const getCampaignColumns = (formatDate) => [
  {
    field: "icon",
    headerName: "",
    ...compactCol({
      renderCell: () => (
        <IconResolver
          name="campaign"
          color={ThemeColors.purple500}
          size={18}
        />
      ),
    }),
  },

  {
    field: "title",
    headerName: "Título",
    ...textCol({ minWidth: 200 }),
  },

  {
    field: "desc",
    headerName: "Descrição",
    ...textCol({
      minWidth: 300,
      renderCell: (params) => truncateText(params.value, 25),
    }),
  },

  {
    field: "start_date",
    headerName: "Início",
    ...textCol({
      minWidth: 160,
      renderCell: (params) => formatDate(params.value),
    }),
  },

  {
    field: "status",
    headerName: "Status",
    ...textCol({
      minWidth: 160,
      renderCell: (params) => (
        <StatusLabel status={params.value} usingOnTable />
      ),
    }),
  },
];
